module.exports = ":host {\n  display: block;\n  width: 100%;\n  clear: both;\n  text-align: right; }\n  :host .pdf-link, :host .csv-link {\n    cursor: pointer;\n    display: inline-block;\n    padding-right: 4px; }\n    :host .pdf-link:hover, :host .csv-link:hover {\n      color: #20abd8; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/pdf-link.scss
// module id = 1519
// module chunks = 0